module.exports = __webpack_public_path__ + "img/bl.04725302.svg";